// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import { prop } from '../../../../common/utils/immutableHelper';

// Selectors
import { debugToolProperty } from '../../../debug/store/debugToolSelector';
import { getCurrentVisibleBoardCanvasOrigin } from '../../../element/selectors/currentBoardSelector';

// Constants
import { DEBUG_TOOLS } from '../../../debug/store/debugToolConstants';

// Styles
import './DebugCanvasDocOrigin.scss';

const getStyle = (canvasOrigin, gridSize) => ({
    left: -prop('x', canvasOrigin) * gridSize,
    top: -prop('y', canvasOrigin) * gridSize,
});

const mapStateToProps = createStructuredSelector({
    debugShowOrigin: debugToolProperty(DEBUG_TOOLS.ZOOM, 'showOrigin'),
    canvasOrigin: getCurrentVisibleBoardCanvasOrigin,
});

const DebugCanvasDocOrigin = (props) => {
    const { debugShowOrigin, canvasOrigin, gridSize } = props;

    if (!debugShowOrigin) return null;

    return <div className="DebugCanvasDocOrigin" style={getStyle(canvasOrigin, gridSize)}></div>;
};

DebugCanvasDocOrigin.propTypes = {
    debugShowOrigin: PropTypes.bool,
    canvasOrigin: PropTypes.object,
    gridSize: PropTypes.number,
};

export default connect(mapStateToProps)(DebugCanvasDocOrigin);
